<template>
  <div :class="`indicator-item ${getCssClass()}`">
    <slot />
  </div>
</template>

<script setup>
  import {
    INDICATOR_ITEM_TYPE_APPROVED,
    INDICATOR_ITEM_TYPE_ATTENTION,
    INDICATOR_ITEM_TYPE_DECLARED,
    INDICATOR_ITEM_TYPE_REJECTED
  } from '../constants/indicator-item';

  const props = defineProps({
    type: {
      type: Number,
      default: INDICATOR_ITEM_TYPE_ATTENTION,
    }
  });

  const getCssClass = () => {
    if (INDICATOR_ITEM_TYPE_ATTENTION === props.type) {
      return 'indicator-item_attention';
    }
    
    if (INDICATOR_ITEM_TYPE_DECLARED === props.type) {
      return 'indicator-item_declared';
    }

    if (INDICATOR_ITEM_TYPE_APPROVED === props.type) {
      return 'indicator-item_approved';
    }

    if (INDICATOR_ITEM_TYPE_REJECTED === props.type) {
      return 'indicator-item_rejected';
    }

    return '';
  };
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  .indicator-item {
    align-items: center;
    background: $indicator-bg-attention;
    border-radius: 2px;
    box-shadow: none;
    color: $indicator-text-attention;
    display: flex;
    font: 700 14px/20px "Nunito Sans";
    height: 24px;
    justify-content: center;
    min-width: 24px;
    text-align: center;
    white-space: nowrap;

    &.indicator-item_declared {
      background: $indicator-bg-declared;
      color: $indicator-text-declared;
    }

    &.indicator-item_approved {
      background: $indicator-bg-approved;
      color: $indicator-text-approved;
    }

    &.indicator-item_rejected {
      background: $indicator-bg-rejected;
      color: $indicator-text-rejected;
    }
  }
</style>